import { Box, CircularProgress, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';

type Props = {
  open: boolean;
  onClose: () => void;
  /** While the cancel request is in flight, closing is disabled to avoid a disconnected UI state. */
  disableClose?: boolean;
};

export default function CancelSubscriptionProcessingModal({ open, onClose, disableClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={disableClose ? undefined : onClose}
      maxWidth='xs'
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      {!disableClose && (
        <IconButton
          aria-label='Close'
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
        >
          <IoClose size={22} />
        </IconButton>
      )}
      <DialogContent sx={{ textAlign: 'center', py: 5, px: 3 }}>
        <Box display='flex' justifyContent='center' mb={2}>
          <CircularProgress size={56} thickness={4} sx={{ color: 'grey.400' }} />
        </Box>
        <Typography variant='body2' color='text.secondary'>
          Processing final charge...
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
